import React, { useState, useEffect } from "react";
import {
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Label,
  Form,
  Button,
  Table,
  Alert,
  Spinner,
} from "reactstrap";

import * as FaIcons from "react-icons/fa";
import axios from "axios";
import "../Bec/bec.scss";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";
import Swal from "sweetalert2";

function AdmSis() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    id: "",
    nombre: "",
    apellido: "",
    id_adm2: "",
    id_adm: "",
    anio_ing_bqef: "",
    ci_bec: "",
    exp_ci_bec: "",
    fec_nac_bec: "",
    edad_bec: "",
    nacio_bec: "",
    serv_mil_bec: "",
    celular: "",
    email: "",
    dir_bec: "",
    estado: "",
    contrasena_lit: "",
    inst_bec: "",
    tip_inst_bec: "",
    anio_grad_bec: "",
    prom_sec_bec: "",
    trab_col_bec: "",
    inst_sup_bec: "",
    dir_sup_bec: "",
    ciu_sup_bec: "",
    tip_sup_bec: "",
    pag_sup_bec: "",
    anio_sup_bec: "",
    matri_sup_bec: "",
    carr_sup_bec: "",
    semanio_sup_bec: "",
    xq_sup_bec: "",
    quien_sup_bec: "",
    dura_sup_bec: "",
    turn_sup_bec: "",
    dist_sup_bec: "",
    transp_sup_bec: "",
    pago_alq_bec: "",
    otrasact_sup_bec: "",
    nom_pad_bec: "",
    edad_pad_bec: "",
    tel_pad_bec: "",
    ocu_pad_bec: "",
    ins_pad_bec: "",
    act_pad_bec: "",
    hor_pad_bec: "",
    ing_pad_bec: "",
    nom_mad_bec: "",
    edad_mad_bec: "",
    tel_mad_bec: "",
    ocu_mad_bec: "",
    ins_mad_bec: "",
    act_mad_bec: "",
    hor_mad_bec: "",
    ing_mad_bec: "",
    vive_padres_bec: "",
    cvive_padres_bec: "",
    solo_bec: "",
    fam_casa_bec: "",
    fam_alq_bec: "",
    casa_alq_bec: "",
    ayu_bec: "",
    quie_ayu_bec: "",
    num_her_bec: "",
    muj_her_bec: "",
    var_her_bec: "",
    igle_nac_bec: "",
    jmen_bec: "",
    cdep_bec: "",
    dat_pas_bec: "",
    cel_pas_bec: "",
    cong_fam_bec: "",
    dsd_cong_bec: "",
    part_igle_bec: "",
    tipcarr_sup_bec: "",
    anio_egre_bqef: "",
    dias_a1: "",
    dias_b1: "",
    dias_c1: "",
    dias_d1: "",
    dias_e1: "",
    dias_f1: "",
    dias_g1: "",
    hor_a1: "",
    hor_a2: "",
    hor_a3: "",
    hor_b1: "",
    hor_b2: "",
    hor_b3: "",
    hor_c1: "",
    hor_c2: "",
    hor_c3: "",
    hor_d1: "",
    hor_d2: "",
    hor_d3: "",
    hor_e1: "",
    hor_e2: "",
    hor_e3: "",
    hor_f1: "",
    hor_f2: "",
    hor_f3: "",
    hor_g1: "",
    hor_g2: "",
    hor_g3: "",
    mat_a1: "",
    mat_b1: "",
    mat_c1: "",
    mat_d1: "",
    mat_e1: "",
    mat_f1: "",
    mat_g1: "",
    horario_anio: "",
    horario_semestre: "",

    // Agrega el campo para la foto de perfil
    foto: "", // O null, dependiendo de tu lógica inicial
  });
  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    nombre: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    apellido: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    id_adm2: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    anio_ing_bqef: { regex: /^\d{4,4}$/, isValid: true },
    email: {
      regex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      isValid: false,
    },
    contrasena_lit: {
      regex:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&%"*#¡¿])[A-Za-z\d@$!%?&%"*#¡¿]{8,}$/,
      isValid: true,
    },
    celular: { regex: /^\d{8,8}$/, isValid: true },
  };

  const [isValid, setIsValid] = useState({
    nombre: true,
    apellido: true,
    id_adm2: true,
    anio_ing_bqef: true,
    email: false,
    celular: true,
    contrasena_lit: true,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));

    if (validation[name]) {
      const isValidValue = validation[name].regex.test(value);
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    } else {
      // Puedes decidir qué hacer si validation[name] no existe
      // Por ejemplo, marcar como válido o inválido, o simplemente ignorar
      setIsValid((prevState) => ({ ...prevState, [name]: true }));
    }
  };

  ///
  const abrirCerrarModalInsertar = () => {
    if (!modalInsertar) {
      limpiarCampos();
    }
    setModalInsertar(!modalInsertar);
  };
  ////limpiar modal
  const limpiarCampos = () => {
    setUsuarioSeleccionado({
      nombre: "",
      apellido: "",
      id_adm2: "",
      email: "",
      contrasena_lit: "",
      celular: "",
    });
  };
  ///
  const closeBtnA = (
    <Button
      className="close"
      onClick={() => abrirCerrarModalInsertar()}
      style={{
        color: "white",
        position: "absolute",
        right: "10px",
        // top: "5%",
        // transform: "translateY(-50%)",
        // background: "none",
        // border: "none",
        // fontSize: "2rem",
      }}
      aria-label="Close"
    >
      {" "}
      &times;
    </Button>
  );

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };
  ////modal

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };

  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  const baseUrl2 = "https://bqef-bo.com/api/A/Adm/apiAdm.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});

  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };

  /////Listado usuarios Administradores del Sistema
  const [data, setData] = useState([]);
  const peticionGet = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl2}?action=getInfoAdm`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setTablaUsuarios(receivedData);
      setData(receivedData);
    } catch (error) {
      console.error(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  ///funcion ver contraseña
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const toggleMostrarContrasena = () => {
    setMostrarContrasena(!mostrarContrasena);
  };
  /////Crear Usuario administrador sistema
  async function peticionPost(e) {
    e.preventDefault();
    let fd = new FormData();
    fd.append("nombre", usuarioSeleccionado.nombre);
    fd.append("apellido", usuarioSeleccionado.apellido);
    fd.append("id_adm2", usuarioSeleccionado.id_adm2);
    fd.append("email", usuarioSeleccionado.email);
    fd.append("contrasena_lit", usuarioSeleccionado.contrasena_lit);
    fd.append("celular", usuarioSeleccionado.celular);

    // Acceder directamente a la primera posición del array
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      const idAdm = dataAdm[0].id_adm;
      fd.append("usu_creacion", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return; // Detener envío si no hay id_adm
    }

    try {
      // const res =
      await axios.post(`${baseUrl2}?action=addAdm`, fd);
      // console.log(res.data);
      mostrarAlertaN();
      peticionGet();
      abrirCerrarModalInsertar();
    } catch (error) {
      console.log(error.response?.data || error);
      mostrarAlertaError();
    }
  }
  /////Modificar Usuario administrador sistema
  const peticionPut = async () => {
    // Verifica que dataAdm tiene datos
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para modificar");
      return; // O maneja el error de otra forma
    }

    const dataToSend = {
      id_adm2: usuarioSeleccionado.id_adm2,
      nombre: usuarioSeleccionado.nombre,
      apellido: usuarioSeleccionado.apellido,
      email: usuarioSeleccionado.email,
      contrasena_lit: usuarioSeleccionado.contrasena_lit,
      celular: usuarioSeleccionado.celular,
      usu_modificacion: idAdm,
    };

    // console.log("id_bec:", usuarioSeleccionado.id_bec);
    // console.log("Datos a enviar:", dataToSend);

    try {
      const response = await axios.put(
        `${baseUrl2}?action=updateAdm`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log(response.data);

      // Actualizar datos en local si es necesario
      const dataNueva = [...data];
      dataNueva.forEach((Usuario) => {
        if (Usuario.id_adm2 === usuarioSeleccionado.id_adm2) {
          Usuario.nombre = usuarioSeleccionado.nombre;
          Usuario.apellido = usuarioSeleccionado.apellido;
          Usuario.email = usuarioSeleccionado.email;
          Usuario.contrasena_lit = usuarioSeleccionado.contrasena_lit;
          Usuario.celular = usuarioSeleccionado.celular;
        }
      });
      setData(dataNueva);
      abrirCerrarModalEditar();
      mostrarAlertaU();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  /////Eliminar Usuario administrador sistema
  async function peticionDelete(id_adm2) {
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para eliminar");
      return;
    }

    try {
      const res = await axios.delete(
        `${baseUrl2}?action=deleteAdm&id_adm=${id_adm2}&usu_modificacion=${idAdm}`,
      );
      abrirCerrarModalEliminar();
      peticionGet();
      mostrarAlertaD();
      console.log(res.data);
    } catch (error) {
      console.error("Error en peticionDelete:", error);
    }
  }

  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);

    switch (caso) {
      case "Editar":
        abrirCerrarModalEditar();
        break;
      case "Eliminar":
        abrirCerrarModalEliminar();
        break;
      default:
        // Opcional: maneja un caso por defecto si 'caso' no coincide con ninguno
        console.warn("Caso no reconocido:", caso);
        break;
    }
  };

  useEffect(() => {
    peticionGet();
    peticionGetAdm();
  }, []);
  ////BARRA BUSQUEDA
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);

  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    // Convert the search term to lowercase for case-insensitive comparison
    const searchTermLower = terminoBusqueda.toLowerCase();

    // Use the filter() method to filter the tableUsers array based on the search term
    const resultadosBusqueda = tablaUsuarios.filter(
      (elemento) =>
        elemento.nombre.toLowerCase().includes(searchTermLower) ||
        elemento.apellido.toLowerCase().includes(searchTermLower) ||
        elemento.id_adm.toString().toLowerCase().includes(searchTermLower) ||
        elemento.celular.toString().toLowerCase().includes(searchTermLower) ||
        elemento.email.toLowerCase().includes(searchTermLower),
    );

    // Set the data to the filtered array
    setData(resultadosBusqueda);
  };
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Nuevo usuario registrado correctamente.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Usuario Modificado.",
      timer: 5000,
      icon: "info",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Usuario Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo registrar.",
      timer: 5000,
      icon: "error",
    });
  };
  //////Filtrar columnas
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");

  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };
  const sortedData = React.useMemo(() => {
    if (!sortField) return data;
    const sorted = [...data].sort((a, b) => {
      if (a[sortField] < b[sortField]) return order === "asc" ? -1 : 1;
      if (a[sortField] > b[sortField]) return order === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [data, sortField, order]);

  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF({ orientation: "portrait" });

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Datos Administrador Sistema",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "Administrador Sistema, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Datos Administradores";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Administrador Sistema";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = data
      .map((iteb) => ({
        nom_b: `${iteb.nombre} ${iteb.apellido}`,
        email: iteb.email,
        celular: iteb.celular,
      }))
      .sort((a, b) => a.nom_b.localeCompare(b.nom_b)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre Becario", dataKey: "nom_b" },
      { header: "Correo", dataKey: "email" },
      { header: "Telf/Cel", dataKey: "celular" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      styles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10,
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };

  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Listado Becarios</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
        </div>

        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg" // cambia size por bsSize
            value={busqueda}
            placeholder="Búsqueda por Nombre, Apellido o Email"
            onChange={handleChangeB}
          />
          <Button color="success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>

        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>N°</th>
              <th>
                <span onClick={() => handleSortingChange("nombre")}>
                  Nombres
                  {sortField === "nombre" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nombre" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("apellido")}>
                  Apellidos
                  {sortField === "apellido" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "apellido" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("id_adm2")}>
                  ID Usuario
                  {sortField === "id_adm2" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "id_adm2" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("email")}>
                  Correo
                  {sortField === "email" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "email" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("contrasena_lit")}>
                  Clave
                  {sortField === "contrasena_lit" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "contrasena_lit" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("celular")}>
                  Celular
                  {sortField === "celular" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "celular" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((Usuario, index) => (
              <tr className="text-center" key={index}>
                <td>{index + 1}</td>
                <td>{Usuario.nombre}</td>
                <td>{Usuario.apellido}</td>
                <td>{Usuario.id_adm2}</td>
                <td>{Usuario.email}</td>
                <td>{Usuario.contrasena_lit}</td>
                <td>{Usuario.celular}</td>
                <td>
                  <Button
                    color="warning"
                    onClick={() => seleccionarUsuario(Usuario, "Editar")}
                  >
                    Editar
                  </Button>{" "}
                  {"  "}
                  <Button
                    color="danger"
                    onClick={() => seleccionarUsuario(Usuario, "Eliminar")}
                  >
                    Eliminar
                  </Button>{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Modal añadir usuario */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo" close={closeBtnA}>
            Insertar Usuario
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombres: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={usuarioSeleccionado.nombre}
                  onChange={handleChange}
                />
                {!isValid.nombre && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  value={usuarioSeleccionado.apellido}
                  onChange={handleChange}
                />
                {!isValid.apellido && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Id Usuario: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="id_adm2"
                  value={usuarioSeleccionado.id_adm2}
                  onChange={handleChange}
                />
                {!isValid.id_adm2 && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <Label>Correo: </Label>
              <Input
                type="text"
                className="form-control"
                name="email"
                value={usuarioSeleccionado.email}
                onChange={handleChange}
              />
              {!isValid.email && (
                <span style={{ color: "red" }}>Correo no válido</span>
              )}
              <FormGroup>
                <Label>Clave: </Label>
                <div style={{ position: "relative" }}>
                  <Input
                    type={mostrarContrasena ? "text" : "password"}
                    className="form-control"
                    name="contrasena_lit"
                    value={usuarioSeleccionado.contrasena_lit}
                    onChange={handleChange}
                  />
                  {/* Icono para mostrar/ocultar */}
                  <span
                    onClick={toggleMostrarContrasena}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {mostrarContrasena ? (
                      <FaIcons.FaEyeSlash /> // icono de ocultar
                    ) : (
                      <FaIcons.FaEye /> // icono de mostrar
                    )}
                  </span>
                </div>
                {!isValid.contrasena_lit && (
                  <span style={{ color: "red" }}>
                    La contraseña debe tener al menos 8 caracteres, incluyendo
                    mayúsculas, minúsculas, números y caracteres especiales
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="celular"
                  value={usuarioSeleccionado.celular}
                  onChange={handleChange}
                />
                {!isValid.celular && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => peticionPost(e)}
              disabled={
                !isValid.nombre ||
                !isValid.apellido ||
                !isValid.id_adm2 ||
                !isValid.email ||
                !isValid.celular ||
                !isValid.contrasena_lit
              }
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Editar */}
        <Modal isOpen={modalEditar} toggle={abrirCerrarModalEditar}>
          <ModalHeader className="header_mo">Modificar Usuario</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>
                  Nombres:{usuarioSeleccionado && usuarioSeleccionado.id_adm2}
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.nombre}
                />
                {!isValid.nombre && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.apellido}
                />
                {!isValid.apellido && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Correo: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.email}
                />
                {!isValid.email && (
                  <span style={{ color: "red" }}>Correo no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Clave: </Label>
                <div style={{ position: "relative" }}>
                  <Input
                    type={mostrarContrasena ? "text" : "password"}
                    className="form-control"
                    name="contrasena_lit"
                    onChange={handleChange}
                    value={
                      usuarioSeleccionado && usuarioSeleccionado.contrasena_lit
                    }
                  />
                  <span
                    onClick={toggleMostrarContrasena}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {mostrarContrasena ? (
                      <FaIcons.FaEyeSlash />
                    ) : (
                      <FaIcons.FaEye />
                    )}
                  </span>
                </div>
                {!isValid.contrasena_lit && (
                  <span style={{ color: "red" }}>
                    La contraseña debe tener al menos 8 caracteres, incluyendo
                    mayúsculas, minúsculas, números y caracteres especiales
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="celular"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.celular}
                />
                {!isValid.celular && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionPut()}
              disabled={
                !isValid.nombre ||
                !isValid.apellido ||
                !isValid.id_adm2 ||
                !isValid.email ||
                !isValid.celular ||
                !isValid.contrasena_lit
              }
            >
              Editar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEditar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Eliminar Usuario*/}
        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">Eliminar Becario</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el Usuario{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nombre}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => {
                console.log(
                  "Eliminando usuario con id_adm:",
                  usuarioSeleccionado.id_adm2,
                );
                peticionDelete(usuarioSeleccionado.id_adm2);
              }}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

export default AdmSis;
